<template>
<span class="kt-switch" :class="_class">
    <label>
        <kt-input type="checkbox" v-bind:disabled="disabled" />
        <slot></slot>
        <span></span>
    </label>
</span>
</template>

<script>
export default {
    props: {
        outline: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
        },
        variant: {
            type: String,
        },
        with_icon: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.outline === true) {
                _class.push('kt-switch--outline')
            }

            if(this.size) {
                _class.push('kt-switch--'+this.size)
            }

            if(this.variant) {
                _class.push('kt-switch--'+this.variant)
            }

            if(this.with_icon === true) {
                _class.push('kt-switch--icon')
            }

            return _class
        }
    }
}
</script>